import { render } from "./InsightView.vue?vue&type=template&id=6ad1b622&scoped=true"
import script from "./InsightView.vue?vue&type=script&lang=js"
export * from "./InsightView.vue?vue&type=script&lang=js"

import "./InsightView.vue?vue&type=style&index=0&id=6ad1b622&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ad1b622"]])

export default __exports__